import { Stack } from '@jarvis/web-stratus-client';

export const ONBOARDING_CENTER_STACK_HOSTNAMES = {
  [Stack.dev]: 'https://onboardingcenter.dev.portalshell.int.hp.com',
  [Stack.pie]: 'https://onboardingcenter.pie.portalshell.int.hp.com',
  [Stack.stage]: 'https://onboardingcenter.stage.portalshell.int.hp.com',
  [Stack.prod]: 'https://start.hp.com',
};

export const DEEPLINKS = {
  INSTANT_INK: 'instantink',
  INSTANT_INK_OVERVIEW: 'instantink/overview',
};

export const GET_SOFTWARE_URL = 'https://start.hp.com/get-software';

export const HP_SUPPORT_HOSTNAME = 'https://support.hp.com';

export const HP_APP_TOU_DOCUMENT_PATH = 'document/ish_12628951-12629012-16';

export const USER_ROLES = {
  ADMIN: 'admin',
  END_USER: 'endUser',
};
